import React from 'react';
import css from './InformationPagesMenu.module.css';
import InformationPagesIcon from './InformationPagesIcon';
import { FormattedMessage } from '../../../util/reactIntl';
import Menu from '../../Menu/Menu';
import MenuLabel from '../../MenuLabel/MenuLabel';
import MenuContent from '../../MenuContent/MenuContent';
import MenuItem from '../../MenuItem/MenuItem';
import NamedLink from '../../NamedLink/NamedLink';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const InformationPagesMenu = props => (
  <Menu>
    <MenuLabel className={css.languageMenuLabel}>
      <InformationPagesIcon />
    </MenuLabel>
    <MenuContent className={css.languageMenuContent}>
      <MenuItem key="LandingPage" className={css.languageMenuItem}>
        <Link to="/">
          {' '}
          <FormattedMessage id="Footer.home" />
          <NamedLink name="LandingPage">{/* <FormattedMessage id="Footer.blog" /> */}</NamedLink>
        </Link>
      </MenuItem>
      <MenuItem key="aboutUsPage" className={css.languageMenuItem}>
        <div>
          <NamedLink name="AboutUsPage">
            <FormattedMessage id="Footer.aboutUs" />
          </NamedLink>
        </div>
      </MenuItem>
      <MenuItem key="blogItem" className={css.languageMenuItem}>
        <div>
            <a href={"blog"}>Blog</a>
        </div>
      </MenuItem>

      <MenuItem key="seguro" className={css.languageMenuItem}>
        <div>
          <NamedLink name="InsurancePage">
            <FormattedMessage id="Footer.seguro" />
          </NamedLink>
        </div>
      </MenuItem>

      <MenuItem key="faqs" className={css.languageMenuItem}>
        <div>
          <NamedLink name="FAQsPage">
            <FormattedMessage id="Footer.faqs" />
          </NamedLink>
        </div>
      </MenuItem>

<MenuItem key="contact" className={css.languageMenuItem}>
  <div>
    <NamedLink name="ContactPage">
      <FormattedMessage id="Footer.contact" defaultMessage="Contact us" />
    </NamedLink>
  </div>
</MenuItem>
    </MenuContent>
  </Menu>
);

export default InformationPagesMenu;
